var moment = require('moment');
import _ from 'lodash'

import ModuleDisplay from '../ModuleDisplay.vue'
import BottomCard from '../BottomCardDisplay.vue'
import RightCard from '../RightCardDisplay.vue'
import Register from '../Register.vue'
import ShareButtons from '../ShareButtons.vue'


/**
 * used as the script part for displaying data on single event page
 * @module Full Event Display
 */
export default {
    name: 'EventDisplayFull',
    data() {
        return {
            detailsShown: false,
            errors: [],
            registerErrors: false,
            processing: false,
            showRegisterBtn: false,
            restrictedEmailEntry: false,
            email: '',
        }
    },
    computed: {
        currentUrl() {
            return window.location.href;
        },

        hasRequiredDetails() {
            return this.$store.getters.hasRequiredDetails;
        },

        modules() {
            return this.$store.getters.modules;
        },

        isFull() {
            return _.values(this.modules).length > 0 && _.values(this.modules).every((n) => {return n.full == true});
        },
        
        currentEvent() {
            return this.$store.getters.currentEvent;
        },

        divisionalInformation() {
            return this.$store.getters.divisionalInformation;
        },

        qualificationsList() {
            var formattedQualifications = [{key: '', description: '(Please select)'}];
            for (const [key, v] of Object.entries(this.currentEvent['qualification'])) {
                var description = v.custom_description ? v.custom_description: v.description;
                formattedQualifications.push({key: key, description: description})
            }
        
            return formattedQualifications;
        },

       

        isLoaded() {
            return this.$store.getters.eventHasLoaded;
        },

        firstModule() {
            return this.$store.getters.firstModule;
        },

        lastModule() {
            return this.$store.getters.lastModule;
        },

        firstModuleStartTime() {
            return this.convertTimeFormat(
                this.firstModule['start_time']
            );
        },

        isSingleDay() {
            return this.firstModule['start_date'] === this.lastModule['start_date']
        },

        fullDateString() {
            let start = this.convertDateFormat(this.currentEvent['start_date']);
            let end = this.convertDateFormat(this.currentEvent['end_date']);

            if (!end) return start;

            return start === end ?
              start :
              `${start} to ${end}`;
        },

        fullCurrentEndDate () {
            // Produce a yyyy-mm-dd formatted string of today's date, because JS is awful and can't do basics like strftime
            let day = String(new Date().getUTCDate()).padStart(2, '0')
            let month = String(new Date().getUTCMonth() + 1).padStart(2, '0')
            let year = new Date().getUTCFullYear()            
                        
            return `${year}-${month}-${day}`;
        },

        fullTimeString() {;
            let fullString = "";

            // if we are dealing with a single day module
            if (this.isSingleDay) {
                let startTime = this.convertTimeFormat(this.firstModule['start_time']);
                let endTime = this.convertTimeFormat(this.lastModule['end_time']);
                let timeAmPm = this.getTimeAmPm(this.lastModule['end_time']);

                fullString = `${startTime} - ${endTime}${timeAmPm}`;
            }
            return fullString.indexOf("nvalid") === -1 ? fullString : "";
        },

        modulesByDate() {
            return this.$store.getters.modulesByDate;
        },

        dateModules() {
            return this.$store.getters.dateModules;
        },

        clashingModules() {
            return this.$store.getters.clashingModules;
        },

        selectedModules() {
            return this.$store.getters.selectedModules;
        },

        hasClashingModules() {
            return _(this.$store.getters.clashingModules)
                .values()
                .flatten()
                .value()
                .length > 0
        },

        locationFromModules() {
            return this.$store.getters.locationFromModules;
        },

        clashingModuleClass(module) {
            return Object.hasOwnProperty(this.clashingModules, module) &&
                this.clashingModules[module].length > 0
        },
    },
    methods: {
        convertDateFormat(dateIn) {
            return moment(dateIn, this.$store.getters.dateFormat).format("ddd D MMM YYYY")
        },

        convertTimeFormat(timeIn) {
            console.log(`timeIn: ${timeIn}`)
            return moment(timeIn, this.$store.getters.timeFormat).format("h:mm");
        },

        getTimeAmPm(timeString) {
            let timeMoment = moment(timeString, this.$store.getters.timeFormat);
            return timeMoment.format("a");
        },

        handleModuleChange({ modules }) {
            this.$store.dispatch({
                type: 'setSelectedModules',
                modules: modules,
            });
        },

        handleFirstnameChange(value) {
            this.$store.dispatch({
                type: 'setFirstname',
                firstname: value
            });
        },

        handleSurnameChange(value) {
            this.$store.dispatch({
                type: 'setSurname',
                surname: value
            });
        },

        handleEmailChange(value) {
            this.$store.dispatch({
                type: 'setEmail',
                email: value
            });
            // Set email value to this variable and call fn
            this.email = value
            this.isInternalEmail()
            
        },

        handlePostcodeChange(value) {
            this.$store.dispatch({
                type: 'setPostcode',
                postcode: value
            });
        },

        handleEmailOptin(value) {
            this.$store.dispatch({
                type: 'setEmailOptin',
                emailOptin: value
            });
        },
        handleDataProtection(value) {
            this.$store.dispatch({
                type: 'setDataProtection',
                dataProtection: value
            });
        },

        handleHighestQualification(value) {
          this.$store.dispatch({
              type: 'setHighestQualification',
              highestQualification: value
          });
        },

        handleDivisionalInformation(value) {
            this.$store.dispatch({
                type: 'setDivisionalInformation',
                divisionalInformation: value
            });
          },  

        handleCurrentStudyProgramme(value) {
            console.log('value from scriptjs ' + value)
            this.$store.dispatch({
                type: 'setCurrentStudyProgramme',
                currentStudyProgramme: value
            });
          },  

        handleRegisterError(value) {
            this.registerErrors = value;
        },

        // removes a single error
        removeError() {
            this.errors.splice(-1, 1);
        },

        addError(errorText) {
            this.errors.push(errorText);
            setTimeout(() => this.removeError(), this.$store.getters.errorWaitTime);
        },

        handleRegisterClick() {
            if (this.detailsShown) {
                this.processing = true;
                this.$store.dispatch('sendRegistration')
                    .then(response => {

                        console.log('response')
                        console.dir(response)

                        // TODO: consider cleaning this up slightly, too much
                        //       branching logic
                        if (response['data']['data']['error']) {
                            this.addError(
                                `There was an unexpected error, and you have not been
                                registered for this event. Details of the error have been sent to
                                technical staff`
                            )
                        } else if (response['data']['data']['registered']) {
                            this.$store.dispatch('handleRegistrationResponse', response['data']['data'])
                        } else {
                            this.addError('We were not able to register you for this event at this time.');
                        }

                    })
                    .catch((error) => {
                        this.addError('We were not able to register you for this event at this time.');
                    });

                if (!this.overEighteenOptin) {
                  this.addError('You must be 18 or over to register for this event online');
                }
            } else {
                this.detailsShown = true;
                this.restrictedEmailEntry = this.currentEvent['is_internal']
            }
        },
        isAbleToRegister() {
            let hasRegisterErrors = this.hasClashingModules ||
                this.registerErrors ||
                (!this.hasRequiredDetails && this.detailsShown) ||
                this.selectedModules.length < 1 || this.isFull

            console.log('errors ' + hasRegisterErrors)

            return hasRegisterErrors
        },
        isOverEighteenChecked(value) {
            this.showRegisterBtn = (value && this.detailsShown)
            this.overEighteenOptin = value
            this.isInternalEmail()
        },
        isInternalEmail() {
          if (this.overEighteenOptin && this.restrictedEmailEntry) {
            this.showRegisterBtn = (this.email.includes("@") && this.email.split("@")[1].includes("ox.ac.uk"))
          } 
        }

    },

    watch: {
        selectedModules() {
            console.log('')
        }
    },

    components: {
        ModuleDisplay,
        RightCard,
        BottomCard,
        Register,
        ShareButtons,
    }
}




// WEBPACK FOOTER //
// ./src/components/EventDisplayFull/script.js